import { EMPTY, formatDelta, formatInteger, formatPercent, isNumber } from './piFormat.js';
import {
  deltaAllowed, deltaPctAllowed, metricText, needsBadge, normalizeMetric, showsValue, stateDescription, stateLabel, stateTone,
} from './piState.js';

export const numberOf = (value) => {
  if (isNumber(value)) return value;
  if (value && typeof value === 'object' && isNumber(value.value)) return value.value;
  return null;
};

export const countText = (value) => (isNumber(value) ? formatInteger(value) : EMPTY);

export const ratioText = (numerator, denominator) => {
  if (!isNumber(numerator) || !isNumber(denominator)) return '';
  return formatInteger(numerator) + ' de ' + formatInteger(denominator);
};

export const shareOf = (part, total) => (isNumber(part) && isNumber(total) && total > 0 ? (part / total) * 100 : null);

const RATE_UNITS = ['pct', 'ratio'];

export const guardedMetric = (raw) => {
  const metric = normalizeMetric(raw);
  if (RATE_UNITS.indexOf(metric.unit) === -1 || metric.denominator !== 0 || !showsValue(metric)) return metric;
  return Object.assign({}, metric, {
    value: null,
    deltaAbs: null,
    deltaPct: null,
    state: 'na',
    stateReason: metric.stateReason || 'denominador zero',
  });
};

export const metricCell = (raw, options) => {
  const settings = options || {};
  const metric = guardedMetric(raw);
  const visible = showsValue(metric);
  const text = metricText(metric);
  const label = stateLabel(metric.state);
  return {
    metric: metric,
    visible: visible,
    text: text,
    badge: needsBadge(metric) && label !== text ? label : '',
    tone: stateTone(metric.state),
    title: stateDescription(metric.state, metric.stateReason),
    reason: metric.stateReason || '',
    ratio: settings.ratio === false ? '' : ratioText(metric.numerator, metric.denominator),
    delta: settings.compare && deltaAllowed(metric)
      ? formatDelta(metric.deltaAbs, deltaPctAllowed(metric) ? metric.deltaPct : null, metric.unit)
      : '',
    sortValue: visible ? metric.value : null,
  };
};

export const pctMetric = (numerator, denominator, extra) => {
  const value = shareOf(numerator, denominator);
  return Object.assign({
    value: value,
    numerator: isNumber(numerator) ? numerator : null,
    denominator: isNumber(denominator) ? denominator : null,
    unit: 'pct',
    state: value === null ? 'na' : 'ok',
    stateReason: value === null && isNumber(denominator) && denominator === 0 ? 'denominador zero' : null,
  }, extra || {});
};

export const sortCaret = (state, key) => {
  if (!state || state.sort !== key) return '';
  return state.desc ? '▼' : '▲';
};

export const paddedKey = (offset) => {
  const value = Math.max(0, Math.floor(Number(offset) || 0));
  const digits = String(value);
  return digits.length >= 4 ? digits : ('0000' + digits).substring(digits.length);
};

export const percentText = (value) => (isNumber(value) ? formatPercent(value) : EMPTY);

export const totalOf = (data, fallback) => {
  const source = data && typeof data === 'object' ? data : {};
  if (isNumber(source.total) && source.total >= 0) return Math.floor(source.total);
  return isNumber(fallback) ? fallback : 0;
};

export const pageOf = (data, fallback) => {
  const source = data && typeof data === 'object' ? data : {};
  if (isNumber(source.page) && source.page >= 1) return Math.floor(source.page);
  return isNumber(fallback) && fallback >= 1 ? fallback : 1;
};

export const ACTIVE_30D_DESCRIPTION = 'Usuários distintos com ação nos 30 dias terminando no último dia fechado do período (mesma janela do MAU).';

export const OUTSIDE_UNIVERSE_TEXT = 'Empresa fora do universo ativo (inativa, bloqueada ou cancelada): não entra nos agregados por empresa.';

export const missingActiveTitle = (row) => {
  const source = row || {};
  if (source.activeUsers && typeof source.activeUsers === 'object') {
    const active = normalizeMetric(source.activeUsers);
    if (active.stateReason) return active.stateReason;
  }
  const rate = normalizeMetric(source.activeSeatsRate);
  if (rate.state === 'na' && rate.stateReason) return rate.stateReason;
  return OUTSIDE_UNIVERSE_TEXT;
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piTable.js